module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_forum2.8d400.png";